import { Text } from '@chakra-ui/react';

type Props = {
  text?: string;
};

const ErrorLabel = ({ text }:Props) => {
  if (!text) return null;

  return (
    <Text textStyle="xs" color="fg.error">{text}</Text>
  );
};

export default ErrorLabel;
